import React from 'react';

const nullFn = _ => null;
const LinkerContext = React.createContext(nullFn);

export default LinkerContext;